import React, { useEffect, useState } from 'react'
import { Typography, Stack, Box, Button, Modal, TextField, InputLabel } from '@mui/material'
import { ReactComponent as DoubleArrowIcon } from "../../../Icons/DoubleArrowIcon.svg"
import { ReactComponent as CelebrationIcon } from "../../../Icons/CelebrationIcon.svg"
import { ReactComponent as ApplicationProcessFileIcon } from "../../../Icons/ApplicationProcessFileIcon.svg"
import { useForm, Controller } from 'react-hook-form'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import { Navigate, useNavigate } from 'react-router-dom'
import { storeData } from '../../../Redux/Feature/ApplicationSlice'
import { useDispatch, useSelector} from 'react-redux'
import { removeData } from '../../../Redux/Feature/ApplicationSlice'
import { jwtDecode } from "jwt-decode";
import axiosInstance from '../../../api/axiosInstance'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import { useTranslation } from 'react-i18next'




const steps = ["Agreement", "Payment", "Success"];

export default function ApplicationSteps({ setFlowCount, email, setEmail, FlowCount }) {
    const style = {
        position: 'absolute',
        top:'50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: {xs : '95%', sm : '90%',lg :'70%'},
        bgcolor: 'background.paper',
        borderRadius : '10px',
        boxShadow: 24,
        display : 'flex',
        flexDirection : {xs : 'column', sm : 'row',lg : 'row'}
      };
      const [open1, setOpen1] = useState(false);

      const handleOpen1 = () => setOpen1(true);
      const handleClose1 = () => setOpen1(false);

    const navigate = useNavigate()
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [showOtp, setShowOtp] = useState(false)
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const data = useSelector((state) => state.AdminData.admin)
    const { t } = useTranslation()

    console.log(data)
    const {
        control,
        handleSubmit,
        formState: { errors },
        getValues,
        watch,
        setValue,
        reset
      } = useForm({
        mode: "onTouched",
        shouldUnregister: false,
      });

      // const [email, setEmail] = useState('')
    
      useEffect(() => {
        dispatch(removeData())
      },[])


      const handleOtpGenerate = async (data) => {
        setEmail(data)
        try {
          setLoading(true)
          await axios.post(`${process.env.REACT_APP_API_URL}/email-otp`, {email : data}).then((response) => {

            if(response.status == 200 && response.data.message == 'Email already exist'){
              dispatch(storeData(response.data.data))
            }

            
            setLoading(false)
          }).catch((error) => {
            setLoading(false)
              toast.error(error.response.data.message, {
                position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
              })
          })
        } catch (error) {
          console.log(error)
          setLoading(false)
        }
      }

const onSubmit = async (data) => {
    try {
      setLoading(true)
        await axios.post(`${process.env.REACT_APP_API_URL}/email-verify-otp`, {email, otp : data.otp}).then((response) => {
          console.log(response)
          if(response.status === 200){
            setFlowCount(2)
            toast.success(response.data.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
          })
          }
          
         setLoading(false)
        }).catch((error) => {
          toast.error(error.response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        })
        })
        setLoading(false)
      } catch (error) {
        console.log(error)
        setLoading(false)
      }
    }

    const isTokenValid = (token) => {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        return decoded.exp > currentTime;
      } catch (error) {
        return false; 
      }
    };


    const fetchUser = async () => {
      try {
        const response = await axiosInstance.get(`/get-paiduser-by-id/${data.id}`)
        console.log(response)
        // setUserData(response?.data?.data)
        if(response?.data?.data?.applicationDone === true){
          setOpen1(true)
        }else{
          handleMoveNext()
        }
      } catch (error) {
        console.log(error)
        if(error.response.status === 401){
          navigate('/login')
          dispatch(removeData())
      }
      }
    }

    // useEffect(() => {
    //   if(data.id){
    //     fetchUser()
    //   }
    // }, [data.id])

    const handleMoveNext = () => {
      const data = JSON.parse(localStorage.getItem("admin"))
      const token = data?.token;
  
    if (!token || !isTokenValid(token)) {
      localStorage.removeItem("admin");
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      navigate('/login')
      console.log('called')
    }
  
    return setFlowCount(2);
    }

    useEffect(() => {
      if(data?.userName){
        handleOtpGenerate(data?.userName)
      }
    }, [data, FlowCount])

    return (
        <>
        <ToastContainer />
      <Modal
      sx={{backdropFilter : 'blur(5px)'}}
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box sx={{width : {xs : '100%', sm : '40%', lg : '40%'}, borderRadius : {xs : '10px 10px 0px 0px', sm : '10px 0px 0px 10px'}}} component='img' src='https://prestigelife.in/assets/img/Rooms/Prestige%20Living%20-%202%20Bed%20with%20Balcony-22.jpg'></Box>
          <Box sx={{p : 2, width : {xs : '100%', lg : '60%'}, mt : {xs : 1, lg : 5}}}>
            {showOtp ? (<>
                <form onSubmit={handleSubmit(onSubmit)}>
            <InputLabel
                      sx={{
                        mb: 1,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      {errors?.otp ? "Otp*" : "Otp"}
                    </InputLabel>
          <Controller 
          name='otp'
          control={control}
          rules={{
            required: 'Otp is required'
        }}
          render={({field}) => (
              <TextField
                      placeholder="Enter otp"
                      error={Boolean(errors.otp) ? true : false}
                      {...field}
                      sx={{
                        width: "100%",
                        backgroundColor: "rgb(249, 250, 251)",
                        borderRadius: 0,
                        "& .MuiInputBase-input": {
                          color: errors?.otp ? "red" : "black",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: errors?.otp
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&:hover fieldset": {
                            borderColor: errors?.otp
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: errors?.otp
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                        },
                      }}
              />
          )}
          />
          {errors?.otp ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        Please enter otp
                      </Typography>
                    ) : null}


                    <Box sx={{display : 'flex', justifyContent : 'flex-end', mt:3}}>
                    <Button type='submit' variant='contained' disabled={loading}>{loading ? 'loading' : 'Submit'}</Button>
                    </Box>
          </form>
            </>) : (<>
                <form onSubmit={handleSubmit(handleOtpGenerate)}>
            <InputLabel
                      sx={{
                        mb: 1,
                        fontSize: "18px",
                        fontWeight: 600,
                        color: "black",
                      }}
                    >
                      {errors?.email ? "Email*" : "Email"}
                    </InputLabel>
          <Controller 
          name='email'
          control={control}
          rules={{
            required: 'Email is required',
            pattern: {
              value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
              message: 'Invalid email address',
            },
        }}
          render={({field}) => (
              <TextField
              type='email'
                      placeholder="Enter email"
                      error={Boolean(errors.email) ? true : false}
                      {...field}
                      sx={{
                        width: "100%",
                        backgroundColor: "rgb(249, 250, 251)",
                        borderRadius: 0,
                        "& .MuiInputBase-input": {
                          color: errors?.email ? "red" : "black",
                        },
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: errors?.email
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&:hover fieldset": {
                            borderColor: errors?.email
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: errors?.email
                              ? "#ff5e74"
                              : "rgba(0, 0, 0, 0.23)",
                          },
                        },
                      }}
              />
          )}
          />
          {errors?.email ? (
                      <Typography
                        style={{ color: "#ff5e74", margin: "0.3rem" }}
                      >
                        Please enter email
                      </Typography>
                    ) : null}


                    <Box sx={{display : 'flex', justifyContent : 'flex-end', mt:3}}>
                    <Button sx={{
            bgcolor: '#009688', // Background color
            color: 'white', // Text color
            '&.Mui-disabled': {
                bgcolor: '#a6a6a6', // Background color for disabled state
                color: 'white', // Text color for disabled state
            }
        }} type='submit' variant='contained' disabled={loading}>{loading ? 'loading..' : 'Verify'}</Button>
                    </Box>
          </form>
            </>)}
            
        </Box>
        </Box>
       
      </Modal>

            <Box padding={{ md: "42px 60px", xs: "30px 20px" }}>
                <Stack gap="7px">
                    <Typography variant="h4_1">{t("Hostel Application Process")}</Typography>
                    <Typography variant="h9_4" color="neutral_4">{t("Your application with ours has 6 primary steps.")}</Typography>
                </Stack>
                <Box mt={5} columnGap={2} rowGap={2} sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center" }}>
                    <Stack p={2} gap={1} sx={{ boxShadow: "2px 31px 25px -3px rgba(0,0,0,0.08)", width: {xs : '80%', sm : '30%',lg : '15%'}, height: "215px", backgroundColor: "#122646", borderRadius: "24px" }}>
                        <Typography variant="h9_4" color="#AAAAAA">{t("Step")} {t("1")}</Typography>
                        <Typography variant="h9_4" color="#FFFFFF">{t("Choose Type")}</Typography>
                        <Stack>
                            <Typography variant="h9_5" color="#CED6FF">{t("Student Hostel Type Entry Date Landing package services & other info")}</Typography>
                           
                        </Stack>
                        <Stack height="100%" alignItems="end" justifyContent="end">
                            <DoubleArrowIcon />
                        </Stack>
                    </Stack>
                    <Stack p={2} gap={1} sx={{ boxShadow: "2px 31px 25px -3px rgba(0,0,0,0.08)", width: {xs : '80%', sm : '30%',lg : '15%'}, height: "215px", backgroundColor: "#122646", borderRadius: "24px" }}>
                        <Typography variant="h9_4" color="#AAAAAA">{t("Step")} {t("2")}</Typography>
                        <Typography variant="h9_4" color="#FFFFFF">{t("Information Form")}</Typography>
                        <Stack>
                            <Typography variant="h9_5" color="#CED6FF">{t("Personal information such as contact type school attended uploadIPA, etc.")}</Typography>
                        </Stack>
                        <Stack height="100%" alignItems="end" justifyContent="end">
                            <DoubleArrowIcon />
                        </Stack>
                    </Stack>
                    <Stack p={2} gap={1} sx={{ boxShadow: "2px 31px 25px -3px rgba(0,0,0,0.08)", width: {xs : '80%', sm : '30%',lg : '15%'}, height: "215px", backgroundColor: "#122646", borderRadius: "24px" }}>
                        <Typography variant="h9_4" color="#AAAAAA">{t("Step")} {t("3")}</Typography>
                        <Typography variant="h9_4" color="#FFFFFF">{t("Confirm Payment")}</Typography>
                        <Stack>
                            <Typography variant="h9_5" color="#CED6FF">{t("Only includes deposit deposit, registration fee, supporting fee and others excluding rent fees")}</Typography>
                        </Stack>
                        <Stack height="100%" alignItems="end" justifyContent="end">
                            <DoubleArrowIcon />
                        </Stack>
                    </Stack>
                    <Stack p={2} gap={1} sx={{ boxShadow: "2px 31px 25px -3px rgba(0,0,0,0.08)", width: {xs : '80%', sm : '30%',lg : '15%'}, height: "215px", backgroundColor: "#122646", borderRadius: "24px" }}>
                        <Typography variant="h9_4" color="#AAAAAA">{t("Step")} {t("4")}</Typography>
                        <Typography variant="h9_4" color="#FFFFFF">{t("Pending Confirmation")}</Typography>
                        <Stack>
                            <Typography variant="h9_5" color="#CED6FF">{t("Within 24 hours not including weekends")}</Typography>
                        </Stack>
                        <Stack height="100%" alignItems="end" justifyContent="end">
                            <DoubleArrowIcon />
                        </Stack>
                    </Stack>
                    <Stack p={2} gap={1} sx={{ boxShadow: "2px 31px 25px -3px rgba(0,0,0,0.08)", width: {xs : '80%', sm : '30%',lg : '15%'}, height: "215px", backgroundColor: "#122646", borderRadius: "24px" }}>
                        <Typography variant="h9_4" color="#AAAAAA">{("Step")} {t("5")}</Typography>
                        <Typography variant="h9_4" color="#FFFFFF">{t("Contract signing & Payment Submission")}</Typography>
                        <Stack>
                            <Typography variant="h9_5" color="#CED6FF">{t("Confirm and sign the format contract pay rent fees")}</Typography>
                        </Stack>
                        <Stack height="100%" alignItems="end" justifyContent="end">
                            <DoubleArrowIcon />
                        </Stack>
                    </Stack>
                    <Stack p={2} gap={1} sx={{ boxShadow: "2px 31px 25px -3px rgba(0,0,0,0.08)", width: {xs : '80%', sm : '30%',lg : '15%'}, height: "215px", backgroundColor: "#122646", borderRadius: "24px" }}>
                        <Typography variant="h9_4" color="#AAAAAA">{t("Step")} {t("6")}</Typography>
                        <Stack height="100%" justifyContent="center" textAlign="center">
                            <Typography variant="h7_1" color="#FFFFFF">{t("Fly to Singapore, Start a new life")}</Typography>
                        </Stack>
                        <Stack alignItems="end" justifyContent="end">
                            <CelebrationIcon />
                        </Stack>
                    </Stack>
                </Box>
                <Stack mt={15} p="30px" rowGap={2} direction={{ sm: "row", xs: "column" }} justifyContent="space-between" alignItems="center" sx={{ border: ".5px solid #1A2461", borderRadius: "20px" }}>
                    <Stack direction="row" gap={3}>
                        <ApplicationProcessFileIcon />
                        <Stack>
                            <Typography variant="h5">{t("Application Process")}</Typography>
                            <Typography variant="h9_4">{t("Login to access your application")}</Typography>
                        </Stack>
                    </Stack>
                    <Button onClick={() => {
                      if(data?.id){
                        fetchUser()
                      }else{
                        navigate('/login')
                      }
                      }} sx={{ height: "40px" }} variant="standard">{t("Fill form")}</Button>
                </Stack>
            </Box>

            <Dialog open={open1} onClose={handleClose1}>
        <DialogTitle>Application already received!</DialogTitle>
        <DialogContent>
          <Typography>We are processing your application, please wait for confirmation.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose1} variant="contained">Close</Button>
          <Button onClick={() => navigate('/account')} variant="contained">Move to dashboard</Button>
        </DialogActions>
      </Dialog>
        </>
    )
}
